import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

/**
 * Uses utc plugin
 * @description Extend the plugins which are to be used over here
 */
dayjs.extend(utc);
